import * as projectActions from '../../actions/project-actions';
import { take, put, call, putResolve, select } from 'redux-saga/effects';
import * as appActions from '../../actions';
import { projectsApi } from '../../../services/projects/projectsApi';
import actions from 'redux-form/lib/actions';
import { enqueueSnackbar } from 'notistack';
const {
  createCustomerGroupMember,
  deleteCustomerGroupMember,
  getCustomerGroups,
  createCustomerGroup,
  updateCustomerGroup,
  deleteCustomerGroup,
} = projectsApi.endpoints;

export function* watchGetCustomerGroups() {
  while (true) {
    yield take(projectActions.PROJECTS_GET_CUSTOMER_GROUPS);

    yield put({
      type: appActions.SET_DATA_REQUESTED,
      payload: `customerGroups`,
    });
    try {
      yield put({ type: appActions.SET_LOADING_STATE, payload: { customerGroups: true } });
      yield putResolve(getCustomerGroups.initiate());
      //yield call(getCustomerGroups);
    } catch (error) {
      console.log('Error fetching customer groups:', error);
      enqueueSnackbar('Failed to load customer groups', { variant: 'error' });
    }
    yield put({
      type: appActions.SET_DATA_RECEIVED,
      payload: `customerGroups`,
    });
  }
}

export function* watchCreateCustomerGroup() {
  while (true) {
    const { payload: customerGroup } = yield take(projectActions.PROJECTS_CREATE_CUSTOMER_GROUP);

    yield put({ type: appActions.SET_APP_STATE, payload: { saving: true } });
    yield putResolve(createCustomerGroup.initiate(customerGroup));
    //yield call(createCustomerGroup, customerGroup);
    yield put({ type: appActions.SET_APP_STATE, payload: { saving: false } });
  }
}

export function* watchUpdateCustomerGroup() {
  while (true) {
    const { payload: customerGroup } = yield take(projectActions.PROJECTS_UPDATE_CUSTOMER_GROUP);

    try {
      yield put({ type: appActions.SET_LOADING_STATE, payload: { customerGroups: true } });
      yield putResolve(updateCustomerGroup.initiate(customerGroup));
    } catch (error) {
      console.log('Error updating customer group:', error);
      enqueueSnackbar('Failed to update customer group', { variant: 'error' });
    }
    //yield call(updateCustomerGroup, customerGroup);
    yield put({ type: appActions.SET_LOADING_STATE, payload: { customerGroups: false } });
  }
}

export function* watchDeleteCustomerGroup() {
  while (true) {
    const { payload: id } = yield take(projectActions.PROJECTS_DELETE_CUSTOMER_GROUP);

    yield put({ type: appActions.SET_APP_STATE, payload: { saving: true } });

    try {
      const result = yield putResolve(deleteCustomerGroup.initiate(id));

      // Check if RTK Query returned an error (rejection)
      if (result.error) {
        const errorMessage =
          result.error.data?.error ||
          result.error.data?.message ||
          result.error.message ||
          'Unknown error';

        // Check if the error is about the customer group having members
        if (errorMessage.includes('Cannot delete CustomerGroup that has members')) {
          yield put({
            type: appActions.SHOW_ALERT,
            payload: {
              msg: 'Cannot delete CustomerGroup that has members',
              type: 'error',
            },
          });
        } else {
          // Generic error message for other errors
          yield put({
            type: appActions.SHOW_ALERT,
            payload: {
              msg: 'Failed to delete customer group',
              type: 'error',
            },
          });
        }
      }
    } catch (error) {
      // Fallback error handling for unexpected errors
      yield put({
        type: appActions.SHOW_ALERT,
        payload: {
          msg: 'Failed to delete customer group',
          type: 'error',
        },
      });
    }

    yield put({ type: appActions.SET_APP_STATE, payload: { saving: false } });
  }
}

export function* watchCreateCustomerGroupMember() {
  while (true) {
    const { payload: customerGroupMember } = yield take(
      projectActions.PROJECTS_CREATE_CUSTOMER_GROUP_MEMBER
    );

    yield put({ type: appActions.SET_APP_STATE, payload: { saving: true } });
    yield putResolve(createCustomerGroupMember.initiate(customerGroupMember));
    // yield call(createCustomerGroupMember, customerGroupMember);
    yield put({ type: appActions.SET_APP_STATE, payload: { saving: false } });
  }
}

export function* watchDeleteCustomerGroupMember() {
  while (true) {
    const { payload: id } = yield take(projectActions.PROJECTS_DELETE_CUSTOMER_GROUP_MEMBER);

    yield put({ type: appActions.SET_APP_STATE, payload: { saving: true } });
    yield putResolve(deleteCustomerGroupMember.initiate(id));
    //yield call(deleteCustomerGroupMember, id);
    yield put({ type: appActions.SET_APP_STATE, payload: { saving: false } });
  }
}
